module.exports = __webpack_public_path__ + "img/support.840155ad.svg";